const getLabelType = (type) => {
  switch (type) {
    case "LECIG VISITE DE SUIVI":
      return "VISITE DE SUIVI";
    case "PARK/LECIG VISITE COMPLEMENTAIRE":
      return "VISITE DOMICILE";
    case "LECIG VISITE":
      return "VISITE DOMICILE";
    case "LECVA":
      return "LECIG VISITE ADAPTATION";
    case "PARK DIETETIS":
      return "SUIVI DIÉTÉTIQUE";
    case "PARK INTENSIS + CR":
      return "SUIVI INTENSIS";
    case "PARK INTENSIS + COURRIER":
      return "SUIVI INTENSIS";
    case "PARK INTENSIS TEL + COURRIER":
      return "SUIVI DISTANCIEL INTENSIS";
    case "PARK VISITE D'INCREMENTATION":
      return "VISITE D'INCREMENTATION";
    case "PARK VISITE DE SUIVI":
      return "VISITE DE SUIVI";
    case "NEURO VISITE INSTALLATION":
      return "INSTALLATION";
    case "NEURO VISITE MOTIVATIONNELLE":
      return "VISITE MOTIVATIONNELLE";
    case "APPEL ASTREINTE":
      return "APPEL ASTREINTE";
    case "DEPANNAGE ASTREINTE PHYSIQUE":
      return "DEPANNAGE ASTREINTE PHYSIQUE";
    case "NEURO PHARMACIE + LIV":
      return "";
    case "PARK/LECIG ACCOMPAGNEMENT CONSULT":
      return "ACCOMPAGNEMENT CONSULTATION";
    case "PARK/LECIG CHGMT FLUX":
      return "CHANGEMENT DE FLUX";
    case "NEURO FORMATION DM":
      return "";
    case "NEURO TRANSMISSION":
      return "";
    case "NEURO EVALUATION TELEPHONIQUE":
      return "EVALUATION TELEPHONIQUE";
    case "PARK POSE/RECUP STAT-ON":
      return "";
    default:
      return "";
  }
};

export default getLabelType;
